export default __webpack_public_path__ + "static/media/android-s2.8262535f.webp";